import { FinancialsRowValue } from './types'

export function getYoYData<T extends FinancialsRowValue>(data: T[]) {
  const yoyData: Array<{ year: string; change: number | null; changePct: number | null }> = []
  const valuesHelpArray: number[] = []

  const valuesArray = [...data].sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year))

  valuesArray.forEach(({ year, value }, i) => {
    if (typeof value !== 'number') return
    valuesHelpArray.push(value)

    const prev = valuesHelpArray[i - 1]
    if (prev === undefined || value === 0 || prev === 0) {
      yoyData.push({ year, change: null, changePct: null })
    } else {
      yoyData.push({ year, change: value - prev, changePct: ((value - prev) / Math.abs(prev)) * 100 })
    }
  })

  return yoyData.reduce<{
    change: Record<string, number | null>
    changePct: Record<string, number | null>
  }>(
    (acc, { year, change, changePct }) => ({
      change: {
        ...acc.change,
        [year]: change,
      },
      changePct: {
        ...acc.changePct,
        [year]: changePct,
      },
    }),
    { change: {}, changePct: {} }
  )
}

export function getIsCompact(numOfCols: number, barWidth: number) {
  // ~1400 is max container width
  const maxContainerWidth = Math.min(window.innerWidth, 1400)

  const barsWindowWidthRatio = (barWidth * numOfCols) / maxContainerWidth
  return barsWindowWidthRatio > 0.65
}
